import { Api } from "./api"

const PATH = 'commission' 

const showCommission = (id,signal) => {
    return Api.get(`${PATH}/${id}`, signal)
}
const updateCommission = (payload,signal) => {
    return Api.post(`${PATH}`,payload, signal)
}


export const commissionApi={
    updateCommission,  
    showCommission     
}